import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useState } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ScandicPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const [activeSet, setActiveSet] = useState<string>('');

    const PRACTICAL_SET = '9c10f7f9-3884-446f-a7ae-da2ba3b56ce6';
    const LANDMARKS_SET = '4bdd7cd6-5660-43aa-b713-a600f88d8971';
    const FOOD_SET = '0e57c9d2-6557-4fda-8e8a-e163ae92bd1b';
    const ACTIVITIES_SET = '4dc31b50-6164-4b5f-bf62-cd317a0d2fc3';

    function showSetIds(set: string) {
        ctxView.setVisibleMapSetIds([set]);
        setActiveSet(set);
    }

    return (
        <S_ScandicPage className={props.className}>
            <CustomMapPage
                mapId={'8ce3f925-10bf-4db8-86c8-26c974adf433'}
                highlightedStyle={''}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/47d1d888-d4fa-445d-8204-11e68d5096b2.png',
                    link: 'https://www.scandichotels.com/hotels/norway/trondheim',
                    linkText: Localization.WEBSITE,
                    logoMarginTop: '0px',
                    logoText: 'Hotel map',
                    logoSubtext: 'Recommended places'
                }}
                controls={<CompanyButtons listTitle="places" exludeHighlight={true} />}
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(88.56deg,#bc4e4e 0%,#a31616 100%)"
                        items={[
                            {
                                iconName: 'location-dot',
                                text: 'All',
                                onClick: () => {
                                    ctxView.setVisibleMapSetIds([
                                        PRACTICAL_SET,
                                        LANDMARKS_SET,
                                        FOOD_SET,
                                        ACTIVITIES_SET
                                    ]);
                                    setActiveSet('');
                                },
                                highlighted: activeSet === ''
                            },
                            {
                                iconName: 'circle-info',
                                text: 'Practical',
                                onClick: () => {
                                    showSetIds(PRACTICAL_SET);
                                },
                                highlighted: activeSet === PRACTICAL_SET
                            },
                            {
                                iconName: 'landmark',
                                text: 'Landmarks',
                                onClick: () => {
                                    showSetIds(LANDMARKS_SET);
                                },
                                highlighted: activeSet === LANDMARKS_SET
                            },
                            {
                                iconName: 'utensils',
                                text: 'Food & Drinks',
                                onClick: () => {
                                    showSetIds(FOOD_SET);
                                },
                                highlighted: activeSet === FOOD_SET
                            },
                            {
                                iconName: 'person-running',
                                text: 'Activities',
                                onClick: () => {
                                    showSetIds(ACTIVITIES_SET);
                                },
                                highlighted: activeSet === ACTIVITIES_SET
                            }
                        ]}
                    />
                }
            />
        </S_ScandicPage>
    );
};

const S_ScandicPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
